import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";


const pastelRed = '#FF6961';
const formatCurrency = (value) => `$${value.toFixed(0)}`

export default function CategorySpendBarChart({ categoryId, categoryName, totalSpend, categoryBudget }) {
   const theme = useTheme();
   const primaryColor = theme.palette.secondary.main;

   // Ensure inputs are numbers
   const spend = Number(totalSpend) || 0;
   const budget = Number(categoryBudget) || 0;

   // --- Determine Chart State ---
   const isOverage = spend > budget;
   const overageAmount = isOverage ? spend - budget : 0;
   const budgetedSpend = isOverage ? budget : spend; // The part colored primary

   // Determine x-axis max value (add buffer)
   const rawMax = isOverage ? spend : budget;
   const xAxisMax = Math.max(rawMax, budget) * 1.1;


   const chartSeries = isOverage
      ? [ // Overage Case: Stacked bar
         {
            data: [budgetedSpend], // Budget part first
            label: 'Budgeted',
            color: primaryColor,
            stack: 'budgetStack',
         },
         {
            data: [overageAmount], // Overage part second
            label: 'Overage',
            color: pastelRed,
            stack: 'budgetStack',
         },
      ]
      : [ // Under Budget Case: Single bar
         {
            data: [budgetedSpend], // Just the spend amount
            label: 'Spend',
            color: primaryColor,
         },
      ];

   const yAxisConfig = [{
      data: [categoryName],
      scaleType: 'band',
      disableLine: true,  // Hide the axis line
      disableTicks: true, // Hide the ticks (which includes labels)
   }];

   const xAxisConfig = [{
      max: xAxisMax, // Dynamic max value with buffer
      valueFormatter: (value) => `$${value.toFixed(0)}`,
   }];

   const chartMargins = {
      top: 5,
      bottom: 20,
      left: 10,
      right: 10
   };

   return (
      <Box sx={{ my: 1 }}> {/* Add some vertical margin */}
         {/* Optional Title (Can be handled outside component too) */}
         <Typography variant="subtitle1" gutterBottom sx={{ textAlign: 'center' }}>
            {categoryName} Spend
         </Typography>
         <BarChart
            borderRadius={5}
            series={chartSeries}
            xAxis={xAxisConfig}
            leftAxis={null}
            layout="horizontal"
            height={100}
            margin={chartMargins}
            grid={{ vertical: true }}
            slotProps={{
               legend: { hidden: true },
            }}
         />
      </Box>
   );
}